import { useRouteError } from "react-router-dom";

export function RouteError() {
  const error = useRouteError() as Error;
  return <div>{error.message}</div>;
}
